var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{staticClass:"ma-0 pa-0",staticStyle:{"top":"-2px"},attrs:{"active":_vm.loading,"color":_vm.color,"indeterminate":true,"height":"4"}})
}
var staticRenderFns = []

export { render, staticRenderFns }